import { render } from "./LawFirmUsersCard.vue?vue&type=template&id=7e1ef348&ts=true"
import script from "./LawFirmUsersCard.vue?vue&type=script&lang=ts"
export * from "./LawFirmUsersCard.vue?vue&type=script&lang=ts"

import "./LawFirmUsersCard.vue?vue&type=style&index=0&id=7e1ef348&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QToolbar,QToolbarTitle,QIcon,QSeparator,QCardSection});
